import { Box } from '@mantine/core';
import { SiestaBackground } from 'src/UI/common/SiestaBackground';

type Props = {
  children: React.ReactNode;
};

export function SiestaBarLayout({ children }: Props) {
  return (
    <Box h="100%" pos="relative" style={{ overflow: 'hidden', borderRadius: 'inherit' }}>
      <SiestaBackground />

      <Box pos="relative" h="100%" px="xl" py="xxxl" style={{ zIndex: 2 }}>
        {children}
      </Box>
    </Box>
  );
}
